import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'laas-certificate-download',
  templateUrl: './certificate-download.component.html',
  styleUrls: ['./certificate-download.component.scss']
})
export class CertificateDownloadComponent extends SessionBaseComponent implements OnInit, OnChanges {

  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() certificateDownloadClick: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;
  @Input() importDocData: any;

  readonly preferenceKey: string;
  isVisible: boolean;
  columns: any[];
  selectedOriginCertificateDatas: any[];
  timezone: string;
  submitted: boolean;
  params:any;
  downloadMergeFileParams!:DownloadMergeFileRequset;

  @ViewChild(DataTableComponent) table!: DataTableComponent;

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private shippingDocumentService: ShippingDocumentService
    ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.RtnDeliveryRemark;
    this.timezone = this.laasSetting.facilityTimeZone;
    this.isVisible = false;
    this.booking = null;

    this.columns = [
      { field: 'deliveryId', header: '交貨單號' },
      { field: 'sku', header: '料號' },
      { field: 'docNo', header: '證件號碼' },
      { field: 'fileName', header: 'FileName' }
    ];

    this.selectedOriginCertificateDatas = [];
    this.submitted = false;
    this.visibleChange = new EventEmitter<any>();
    this.certificateDownloadClick = new EventEmitter<any>();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    console.log("ngOnInit:",this.importDocData);
  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  rowSelected(event: any): void {
    console.log("rowSelected:",event);
  }

  rowUnSelected(event: any): void {
    console.log("rowUnSelected",event);
  }


  getCertificateFile(event: any): void {

    if(this.selectedOriginCertificateDatas.length == 0){
      //請勾選檔案
      this.translateService.get('BoookingSearch.Alert.TickFile')
      .subscribe({
        next: result => {
          this.toastService.warn(result);
        }
      });
      return;
    }

    console.log("selectedOriginCertificateDatas:", this.selectedOriginCertificateDatas);

    if(this.selectedOriginCertificateDatas.length == 0){
      //查無資料_
      this.translateService.get('BoookingSearch.Info.NoDatafound')
      .subscribe({
        next: result => {
          this.toastService.info(result);
        }
      });
      return;
    }

    var referenceKeys = this.selectedOriginCertificateDatas.map((x: any) => { return x.docReferenceKey; });
    const downloadFunction:string = "bookingSearchDownloadDeclarationFile"
    this.downloadMergeFile(referenceKeys, downloadFunction);
  }

  private fileNotExist(results: any[]): boolean {
    let isNotExist = results?.length === 0;
    isNotExist = isNotExist || results[0].attachFileDetailBeans?.length === 0;
    isNotExist = isNotExist || isNullOrEmpty(results[0].attachFileDetailBeans[0].file);
    isNotExist = isNotExist || isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName);
    return isNotExist;
  }

  downloadAttachFile(): void {
    this.bookingService
      .downloadShippingDocuments(
        'ExportDeclarationExcel',
        'referenceType',
        [this.booking?.bookingNo],
        this.userProfile.loginAccount,
        false,
        ''
      )
      .subscribe({
        next: (results: any[]) => {
          // 無檔案可下載
          if (this.fileNotExist(results)) {
            this.translateService
              .get('BoookingSearch.Info.NoFileDownload')
              .subscribe({
                next: (result) => {
                  this.toastService.info(result);
                },
              });
            return;
          }
          for (const fileInfo of results[0].attachFileDetailBeans) {
            const byteStr = atob(fileInfo.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }
            const data: Blob = new Blob(
              [int8Array]
            );
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = fileInfo.fileName;
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        },
      });
  }

  private downloadMergeFile(referenceKeys: Array<string>, downloadFunction: string): void {

    console.log("ReferenceKeys = " + referenceKeys);

    this.downloadMergeFileParams = {
      docReference: ["Warehousing"],
      referenceKeys: referenceKeys,
      docTypes: ["ImportDeclaration"],
      remarks: null,
      downloadFunction: downloadFunction
    };

    this.shippingDocumentService.downloadMergeFile(this.downloadMergeFileParams).subscribe(
      {
        next: x => {
          if (x.isMutipleFile == "SINGLE") {
            const byteStr = atob(x.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }
            const data: Blob = new Blob(
              [int8Array], { type: 'application/octet-stream' }
            );
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = x.fileName;
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();

            this.loader.hide();
          } else {
            const byteStr = atob(x.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }
            const data: Blob = new Blob(
              [int8Array], { type: 'application/zip' }
            );
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = x.fileName;
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();
            this.loader.hide();
          }
        },
        error: err => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      });
  }

}
